import { WelcomeOnboarding } from '../components/WelcomeOnboarding';
import { MessageBell } from '../components/MessageBell';
import { AbonnementModal } from '../components/AbonnementModal';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BottomNav } from '../components/BottomNav';
import { useAuth } from '../context/AuthContext';
import { api } from '../services/api';
import { Spinner, Alert } from '../components/UI';
import logoBrandStarter from '../assets/logo_brandstarter.png';

const MODULE_INFO = [
  { num: 1, emoji: '💡', titre: "Ton idée & ta vision",         desc: "Clarifie ton concept, le problème résolu, ta différence.",                        premium: false, temps: 20 },
  { num: 2, emoji: '🎯', titre: "Ton persona client idéal",     desc: "Définis avec précision à qui tu t'adresses.",                                     premium: false, temps: 25 },
  { num: 3, emoji: '❤️', titre: "Raison d'être et valeurs",      desc: "Ton pourquoi, ta mission, ta vision et tes 3 valeurs, vécues au quotidien.",                    premium: false, temps: 30 },
  { num: 4, emoji: '🧭', titre: "Positionnement et promesse",   desc: "Tes alternatives, ta différence, ta promesse et ta phrase de positionnement.",                     premium: false, temps: 35 },
  { num: 5, emoji: '📢', titre: "Personnalité et voix",          desc: "Ta personnalité, ton ton de voix, ton pitch, ta bio et ton accroche.",                               premium: false, temps: 30 },
  { num: 6, emoji: '📦', titre: "Construction de l'offre",      desc: "Structure, pricing, promesse, une offre qui se vend toute seule.",              premium: true,  temps: 40 },
  { num: 11, emoji: '📍', titre: "Google Business Profile",        desc: "Ta fiche Google complète : description, catégories, photos, avis. À copier-coller.", premium: true,  temps: 30 },
  { num: 12, emoji: '📣', titre: "Publicité Meta",                desc: "Ta première campagne Facebook et Instagram : cible, publicités, budget de test.", premium: true,  temps: 35 },
  { num: 13, emoji: '🤝', titre: "Premiers clients",             desc: "Tes messages, ton lead magnet et tes relances, prêts à envoyer.", premium: true,  temps: 30 },
  { num: 7, emoji: '🚀', titre: "Plan de lancement 90 jours",   desc: "Feuille de route OKR/KPI pour tes premiers 90 jours.",                          premium: true,  temps: 45 },
  { num: 8, emoji: '📱', titre: "Stratégie réseaux sociaux",    desc: "Plan contenu 30 jours, piliers, formats et funnel adaptés à ton persona.",      premium: true,  temps: 40 },
  { num: 9, emoji: '🎯', titre: "Acquisition client",           desc: "Canal principal, lead magnet, parcours prospect et métriques prévisibles.",     premium: true,  temps: 35 },
  { num: 10, emoji: '🔁', titre: "Fidélisation client",          desc: "Diagnostic personnalisé et système de fidélisation adapté à ton activité.",    premium: true,  temps: 25 },
];

const GAINS = [
  { ico: '🎯', titre: "Un positionnement qui te fait choisir", desc: "Tu sais exactement qui tu es, pour qui tu travailles et pourquoi te préférer." },
  { ico: '🎨', titre: "Une identité cohérente partout",        desc: "Logo, couleurs, ton de voix, tout aligné et professionnel dès le premier jour." },
  { ico: '📈', titre: "Des clients attirés naturellement",     desc: "Un discours clair, moins d'efforts pour convaincre, plus de conversions." },
];

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;1,500&family=Inter:wght@300;400;500;600;700&display=swap');
  :root { --g:#173B34; --o:#E4572E; --c:#F6F2EC; --d:#222222; --line:#EDE9E2; }

  .pp { background: var(--c); min-height: 100vh; font-family: 'Inter', sans-serif; color: var(--d); }

  /* NAV */
  .pp-nav {
    background: #fff; border-bottom: 1px solid var(--line);
    position: sticky; top: 0; z-index: 100;
    display: flex; align-items: center; justify-content: space-between;
    padding: 0 24px; height: 72px;
  }
  .pp-nav-logo { display: flex; align-items: center; gap: 10px; }
  .pp-nav-logo img { height: 44px; width: auto; }  .pp-nav-right { display: flex; align-items: center; gap: 14px; }
  .pp-nav-user { font-size: 13px; color: #888; }
  .pp-nav-btn {
    background: var(--g); color: #F6F2EC; border: none; border-radius: 999px;
    padding: 8px 18px; font-size: 13px; font-weight: 600; cursor: pointer;
    font-family: 'Inter', sans-serif;
  }
  .pp-nav-profil {
    background: transparent; color: var(--g); border: 1.5px solid var(--line);
    border-radius: 999px; padding: 7px 16px; font-size: 13px; font-weight: 600;
    cursor: pointer; font-family: 'Inter', sans-serif;
  }

  /* HERO */
  .pp-hero {
    background: var(--g); padding: 36px 24px 0;
    position: relative; overflow: hidden;
  }
  .pp-hero::before {
    content: ''; position: absolute; top: -80px; right: -80px;
    width: 320px; height: 320px; border-radius: 50%;
    background: rgba(228,87,46,0.1); pointer-events: none;
  }
  .pp-hero-inner {
    max-width: 860px; margin: 0 auto;
    display: grid; grid-template-columns: 1fr 140px; gap: 24px;
    align-items: end; position: relative; z-index: 2;
    padding-right: 16px;
  }
  .pp-tag {
    display: inline-flex; align-items: center; gap: 7px;
    background: rgba(228,87,46,0.15); border: 1px solid rgba(228,87,46,0.3);
    border-radius: 999px; padding: 5px 14px;
    font-size: 11px; font-weight: 700; color: var(--o); letter-spacing: .08em;
    margin-bottom: 16px;
  }
  .pp-tag-dot { width: 6px; height: 6px; border-radius: 50%; background: var(--o); }
  .pp-hero h1 {
    font-family: 'Playfair Display', serif;
    font-size: clamp(24px, 3.5vw, 36px); color: #fff;
    font-weight: 700; line-height: 1.15; margin-bottom: 10px;
  }
  .pp-hero h1 em { font-style: italic; color: var(--o); }
  .pp-hero-sub { font-size: 14px; color: rgba(246,242,236,0.55); line-height: 1.7; max-width: 440px; margin-bottom: 24px; }
  .pp-stats { display: flex; gap: 8px; }
  .pp-stat {
    background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.08);
    border-radius: 12px; padding: 11px 16px; text-align: center;
  }
  .pp-stat-val { font-family: 'Playfair Display', serif; font-size: 18px; color: #fff; line-height: 1; margin-bottom: 3px; }
  .pp-stat-lbl { font-size: 9.5px; color: rgba(246,242,236,0.35); letter-spacing: .08em; text-transform: uppercase; }

  /* RING */
  .pp-ring-wrap { flex-shrink: 0; display: flex; flex-direction: column; align-items: center; gap: 8px; padding-bottom: 8px; }
  .pp-ring { width: 110px; height: 110px; }
  .pp-ring-track { fill: none; stroke: rgba(255,255,255,0.08); stroke-width: 8; }
  .pp-ring-fill {
    fill: none; stroke: var(--o); stroke-width: 8; stroke-linecap: round;
    transform: rotate(-90deg); transform-origin: 50% 50%;
    transition: stroke-dasharray .6s ease;
  }
  .pp-ring-val { font-family: 'Playfair Display', serif; font-size: 22px; font-weight: 700; fill: white; text-anchor: middle; }
  .pp-ring-lbl { font-size: 9px; fill: rgba(246,242,236,0.4); text-anchor: middle; letter-spacing: .08em; }
  .pp-ring-sub { font-size: 11px; color: rgba(246,242,236,0.4); text-align: center; letter-spacing: .06em; text-transform: uppercase; }

  /* HERO BAR */
  .pp-hero-bar {
    background: rgba(0,0,0,0.15); border-top: 1px solid rgba(255,255,255,0.08);
    margin: 24px -24px 0; padding: 11px 24px;
    display: flex; align-items: center; justify-content: space-between;
    font-size: 12.5px;
  }
  .pp-hero-bar-l { color: rgba(246,242,236,0.45); display: flex; align-items: center; gap: 6px; }
  .pp-hero-bar-r { color: var(--o); font-weight: 700; }

  /* BODY */
  .pp-body { max-width: 860px; margin: 0 auto; padding: 28px 24px 60px; }

  /* NEXT STEP */
  .pp-next {
    background: #fff; border-radius: 18px; padding: 20px 22px;
    border: 1.5px solid var(--o); margin-bottom: 24px;
    display: flex; align-items: center; justify-content: space-between; gap: 16px;
    box-shadow: 0 4px 16px rgba(228,87,46,0.1);
  }
  .pp-next-left { display: flex; align-items: center; gap: 14px; }
  .pp-next-ico {
    width: 46px; height: 46px; border-radius: 12px;
    background: rgba(228,87,46,0.1); display: flex; align-items: center;
    justify-content: center; font-size: 20px; flex-shrink: 0;
  }
  .pp-next-label { font-size: 10.5px; font-weight: 700; letter-spacing: .1em; text-transform: uppercase; color: var(--o); margin-bottom: 4px; }
  .pp-next-title { font-family: 'Playfair Display', serif; font-size: 16px; font-weight: 700; color: var(--d); margin-bottom: 2px; }
  .pp-next-desc { font-size: 12.5px; color: #888; line-height: 1.5; }
  .pp-next-btn {
    background: var(--o); color: #fff; border: none; border-radius: 999px;
    padding: 11px 22px; font-size: 13.5px; font-weight: 700; cursor: pointer;
    white-space: nowrap; font-family: 'Inter', sans-serif; flex-shrink: 0;
    box-shadow: 0 4px 14px rgba(228,87,46,0.3); transition: all .15s;
    text-decoration: none; display: inline-block;
  }
  .pp-next-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 20px rgba(228,87,46,0.4); }

  /* SECTION LABEL */
  .pp-sec-lbl {
    font-size: 10px; font-weight: 700; letter-spacing: .14em; text-transform: uppercase;
    color: #B0A898; margin-bottom: 12px; display: flex; align-items: center; gap: 10px;
  }
  .pp-sec-lbl::after { content: ''; flex: 1; height: 1px; background: var(--line); }

  /* GAINS */
  .pp-gains { display: grid; grid-template-columns: repeat(3,1fr); gap: 12px; margin-bottom: 28px; }
  .pp-gain { background: #fff; border: 1px solid var(--line); border-radius: 14px; padding: 18px; }
  .pp-gain-ico { font-size: 22px; margin-bottom: 10px; }
  .pp-gain-title { font-size: 13.5px; font-weight: 700; color: var(--g); margin-bottom: 5px; }
  .pp-gain-desc { font-size: 12.5px; color: #888; line-height: 1.55; }

  /* MODULES */
  .pp-modules { display: flex; flex-direction: column; gap: 10px; margin-bottom: 28px; }
  .pp-mod {
    background: #fff; border: 1px solid var(--line); border-radius: 16px;
    padding: 18px 20px; display: flex; align-items: center; gap: 16px;
    text-decoration: none; color: inherit;
    transition: transform .15s, box-shadow .15s;
    position: relative; overflow: hidden; cursor: pointer;
  }
  .pp-mod:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(23,59,52,0.08); }
  .pp-mod.done { border-left: 4px solid var(--g); border-radius: 0 16px 16px 0; }
  .pp-mod.active { border: 1.5px solid var(--g); box-shadow: 0 4px 20px rgba(23,59,52,0.1); }
  .pp-mod.active::before { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 2px; background: linear-gradient(90deg, var(--g), var(--o)); }
  .pp-mod.locked { opacity: .5; cursor: not-allowed; }
  .pp-mod.locked:hover { transform: none; box-shadow: none; }
  .pp-mod.premium-locked { opacity: .65; cursor: not-allowed; }
  .pp-mod.premium-locked:hover { transform: none; box-shadow: none; }

  .pp-circle {
    width: 46px; height: 46px; border-radius: 14px; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center; font-size: 20px;
  }
  .pp-circle.done { background: var(--g); color: #fff; font-size: 17px; }
  .pp-circle.active { background: rgba(228,87,46,0.1); border: 1.5px solid rgba(228,87,46,0.3); }
  .pp-circle.locked { background: #F5F3EF; }
  .pp-circle.premium { background: rgba(23,59,52,0.06); }

  .pp-mod-info { flex: 1; min-width: 0; }
  .pp-mod-num { font-size: 9.5px; font-weight: 700; letter-spacing: .12em; text-transform: uppercase; color: #B0A898; margin-bottom: 3px; }
  .pp-mod-title { font-family: 'Playfair Display', serif; font-size: 16px; color: var(--d); font-weight: 600; margin-bottom: 3px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .pp-mod-desc { font-size: 12.5px; color: #888; line-height: 1.5; }

  .pp-mod-right { margin-left: auto; display: flex; flex-direction: column; align-items: flex-end; gap: 6px; flex-shrink: 0; }
  .pp-badge { font-size: 10.5px; font-weight: 700; padding: 3px 10px; border-radius: 999px; }
  .pp-badge-done { background: rgba(23,59,52,0.1); color: var(--g); }
  .pp-badge-active { background: var(--g); color: #fff; }
  .pp-badge-pro { background: rgba(228,87,46,0.1); color: var(--o); border: 1px solid rgba(228,87,46,0.25); }
  .pp-mod-time { font-size: 11px; color: #C0B8B0; display: flex; align-items: center; gap: 4px; }

  /* SEPARATOR PREMIUM */
  .pp-separator {
    display: flex; align-items: center; gap: 10px; padding: 4px 0;
  }
  .pp-separator-line { flex: 1; height: 1px; background: var(--line); }
  .pp-separator-label { font-size: 10.5px; font-weight: 700; letter-spacing: .1em; text-transform: uppercase; color: #C0B8B0; padding: 0 8px; }

  /* PREMIUM CTA */
  .pp-cta {
    background: var(--g); border-radius: 20px; padding: 32px 28px;
    display: grid; grid-template-columns: 1fr auto; gap: 24px; align-items: center;
    position: relative; overflow: hidden;
  }
  .pp-cta::before { content: ''; position: absolute; top: -60px; right: -60px; width: 200px; height: 200px; border-radius: 50%; background: rgba(228,87,46,0.1); pointer-events: none; }
  .pp-cta-left { position: relative; z-index: 2; }
  .pp-cta-eyebrow { font-size: 10.5px; font-weight: 700; letter-spacing: .14em; text-transform: uppercase; color: var(--o); margin-bottom: 10px; display: flex; align-items: center; gap: 8px; }
  .pp-cta-eyebrow::before { content: ''; width: 16px; height: 2px; background: var(--o); }
  .pp-cta-title { font-family: 'Playfair Display', serif; font-size: 22px; color: #fff; font-weight: 700; line-height: 1.2; margin-bottom: 10px; }
  .pp-cta-desc { font-size: 13.5px; color: rgba(246,242,236,0.55); line-height: 1.65; }
  .pp-cta-right { position: relative; z-index: 2; text-align: center; }
  .pp-cta-btn {
    background: var(--o); color: #fff; border: none; border-radius: 999px;
    padding: 14px 26px; font-size: 14px; font-weight: 700; cursor: pointer;
    font-family: 'Inter', sans-serif; display: block; white-space: nowrap;
    box-shadow: 0 4px 16px rgba(228,87,46,0.35); transition: all .15s;
    text-decoration: none;
  }
  .pp-cta-btn:hover { transform: translateY(-1px); box-shadow: 0 8px 24px rgba(228,87,46,0.45); }
  .pp-cta-note { font-size: 11px; color: rgba(246,242,236,0.3); margin-top: 8px; }

  /* ALERT */
  .pp-alert {
    background: rgba(228,87,46,0.08); border: 1px solid rgba(228,87,46,0.25);
    border-radius: 12px; padding: 14px 18px; font-size: 14px; color: #8B3A20;
    margin-bottom: 20px; display: flex; align-items: flex-start; gap: 10px;
  }

  /* RESPONSIVE */
  @media(max-width:700px){
    .pp-hero-inner { grid-template-columns: 1fr; }
    .pp-ring-wrap { display: none; }
    .pp-gains { grid-template-columns: 1fr; }
    .pp-cta { grid-template-columns: 1fr; }
    .pp-cta-right { text-align: left; }
    .pp-next { flex-direction: column; align-items: flex-start; }
    .pp-next-btn { width: 100%; text-align: center; }
    .pp-hero { padding: 28px 16px 0; }
    .pp-body { padding: 20px 16px 48px; }
    .pp-nav { padding: 0 16px; height: 56px; }
    .pp-nav-user { display: none; }
    .pp-hide-m, .pp-nav-btn { display: none !important; }
    .pp-mod-title { white-space: normal; }
  }
  @media(max-width:480px){
    .pp-stats { flex-wrap: wrap; }
    .pp-stat { flex: 1; min-width: 80px; }
  }
`;

export function ParcoursPage() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showAbo, setShowAbo] = useState(false);

  useEffect(() => {
    api.getModules()
      .then(setData)
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F6F2EC' }}>
      <Spinner size={36} />
    </div>
  );

  const joursRestants  = data?.joursRestants ?? user?.joursRestants ?? 0;
  const moduleActuel   = data?.moduleActuel ?? 1;
  const modulesValides = data?.modules?.filter(m => m.valide).map(m => m.num) || [];
  const nbGratuits     = modulesValides.filter(n => n <= 5).length;
  const pct            = Math.round((nbGratuits / 5) * 100);

  const getStatut = (num) => {
    if (modulesValides.includes(num)) return 'valide';
    if (num === moduleActuel) return 'actif';
    return 'verrouille';
  };

  const canAccess = (num, premium) => {
    if (user?.isAdmin) return true;
    if (joursRestants === 0) return false;
    if (premium) return data?.premiumDebloque;
    const s = getStatut(num);
    return s === 'valide' || s === 'actif';
  };

  const moduleActuelInfo = MODULE_INFO.find(m => m.num === moduleActuel);
  const isFirst = modulesValides.length === 0;
  const tempsRestant = MODULE_INFO.filter(m => !modulesValides.includes(m.num) && !m.premium).reduce((acc, m) => acc + m.temps, 0);

  const heroMessage = isFirst
    ? "Tu ne sais pas encore par où commencer ? Ce parcours te guide de ton idée à une identité de marque complète, pas à pas."
    : modulesValides.length >= 5
    ? "Bravo, tu as complété les 5 modules gratuits. Ton identité de marque est posée. Les modules Premium t'attendent pour aller plus loin."
    : `Tu avances bien. ${nbGratuits} module${nbGratuits > 1 ? 's' : ''} complété${nbGratuits > 1 ? 's' : ''} sur 5. Continue sur ta lancée.`;

  // Calcul dashoffset ring (circonférence = 2*PI*45 ≈ 283)
  const ringOffset = 283 - (283 * pct / 100);

  return (
    <>
      <style>{CSS}</style>
      <div className="pp">
        <WelcomeOnboarding />

        {/* NAV */}
        <nav className="pp-nav">
          <div className="pp-nav-logo">
            <img src={logoBrandStarter} alt="BrandStarter"/>
          </div>
          <div className="pp-nav-right">
            <span className="pp-nav-user">Bonjour, {user?.prenom} 👋</span>
            <MessageBell />
            {user?.isAdmin && (
              <button className="pp-nav-profil" onClick={() => navigate('/admin')} style={{borderColor:'var(--o)',color:'var(--o)'}}>⚙️ Admin</button>
            )}
            <button className="pp-nav-profil pp-hide-m" onClick={() => navigate('/ma-marque')} style={{borderColor:'var(--o)',color:'var(--o)'}}>Ma marque</button>
            <button className="pp-nav-profil pp-hide-m" onClick={() => navigate('/profil')}>Mon profil</button>
            <button className="pp-nav-btn" onClick={() => { logout(); navigate('/connexion'); }}>Déconnexion</button>
          </div>
        </nav>

        {/* HERO */}
        <div className="pp-hero">
          <div className="pp-hero-inner">
            <div>
              <div className="pp-tag"><span className="pp-tag-dot"></span>{modulesValides.length > 0 ? 'Parcours en cours' : 'Parcours prêt à démarrer'}</div>
              <h1>Construis ta marque.<br/><em>Pas à pas, avec méthode.</em></h1>
              <p className="pp-hero-sub">{heroMessage}</p>
              <div className="pp-stats">
                <div className="pp-stat"><div className="pp-stat-val">5</div><div className="pp-stat-lbl">Modules gratuits</div></div>
                <div className="pp-stat"><div className="pp-stat-val">{user?.isAdmin ? '∞' : joursRestants > 0 ? `${joursRestants}j` : 'Expiré'}</div><div className="pp-stat-lbl">Jours restants</div></div>
                <div className="pp-stat"><div className="pp-stat-val">{pct}%</div><div className="pp-stat-lbl">Complété</div></div>
              </div>
            </div>
            <div className="pp-ring-wrap">
              <svg className="pp-ring" viewBox="0 0 100 100">
                <circle className="pp-ring-track" cx="50" cy="50" r="45"/>
                <circle className="pp-ring-fill" cx="50" cy="50" r="45"
                  strokeDasharray={`${283 * pct / 100} 283`}
                  style={{ strokeDasharray: `${283 * pct / 100} 283` }}
                />
                <text className="pp-ring-val" x="50" y="46">{nbGratuits}/5</text>
                <text className="pp-ring-lbl" x="50" y="60">MODULES</text>
              </svg>
              <div className="pp-ring-sub">{pct}% accompli</div>
            </div>
          </div>
          <div className="pp-hero-bar">
            <div className="pp-hero-bar-l">
              <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="rgba(246,242,236,0.4)" strokeWidth="1.2"/><path d="M8 5v3.5L10 10" stroke="rgba(246,242,236,0.4)" strokeWidth="1.2" strokeLinecap="round"/></svg>
              Temps estimé restant
            </div>
            <div className="pp-hero-bar-r">{tempsRestant > 0 ? `~${tempsRestant} min pour compléter les modules gratuits` : 'Modules gratuits complétés 🎉'}</div>
          </div>
        </div>

        {/* BODY */}
        <div className="pp-body">

          {error && <div className="pp-alert">⚠️ {error}</div>}
          {joursRestants === 0 && !user?.isAdmin && (
            <div className="pp-alert">
              ⏱️ Tes 20 jours gratuits sont terminés. Contacte Stratvente pour continuer.
            </div>
          )}

          {/* NEXT STEP */}
          {moduleActuelInfo && canAccess(moduleActuel, moduleActuelInfo.premium) && (
            <div className="pp-next">
              <div className="pp-next-left">
                <div className="pp-next-ico">{moduleActuelInfo.emoji}</div>
                <div>
                  <div className="pp-next-label">Prochaine étape</div>
                  <div className="pp-next-title">{moduleActuelInfo.titre}</div>
                  <div className="pp-next-desc">{moduleActuelInfo.desc} · ~{moduleActuelInfo.temps} min</div>
                </div>
              </div>
              <a href={`/module/${moduleActuel}`} className="pp-next-btn" target="_blank" rel="noreferrer">Continuer →</a>
            </div>
          )}

          {/* GAINS */}
          <div className="pp-sec-lbl">Ce que tu obtiens au bout du parcours</div>
          <div className="pp-gains">
            {GAINS.map((g, i) => (
              <div key={i} className="pp-gain">
                <div className="pp-gain-ico">{g.ico}</div>
                <div className="pp-gain-title">{g.titre}</div>
                <div className="pp-gain-desc">{g.desc}</div>
              </div>
            ))}
          </div>

          {/* MODULES */}
          <div className="pp-sec-lbl">Ton parcours</div>
          <div className="pp-modules">

            {MODULE_INFO.filter(m => !m.premium).map(mod => {
              const statut = getStatut(mod.num);
              const acces  = canAccess(mod.num, false);
              const valide = statut === 'valide';
              const actif  = statut === 'actif';
              const circleClass = valide ? 'done' : actif ? 'active' : 'locked';
              const modClass = `pp-mod ${valide ? 'done' : ''} ${actif ? 'active' : ''} ${!acces && !valide ? 'locked' : ''}`;

              const inner = (
                <>
                  <div className={`pp-circle ${circleClass}`}>{valide ? '✓' : mod.emoji}</div>
                  <div className="pp-mod-info">
                    <div className="pp-mod-num">Module {String(mod.num).padStart(2,'0')}</div>
                    <div className="pp-mod-title">{mod.titre}</div>
                    <div className="pp-mod-desc">{mod.desc}</div>
                  </div>
                  <div className="pp-mod-right">
                    {valide && <span className="pp-badge pp-badge-done">✓ Complété</span>}
                    {actif && <span className="pp-badge pp-badge-active">En cours</span>}
                    {!acces && !valide && <span style={{fontSize:18}}>🔒</span>}
                    <div className="pp-mod-time">⏱ {mod.temps} min</div>
                  </div>
                </>
              );

              if (acces) {
                return (
                  <a key={mod.num} href={`/module/${mod.num}`} target="_blank" rel="noreferrer" className={modClass}>
                    {inner}
                  </a>
                );
              }
              return <div key={mod.num} className={modClass}>{inner}</div>;
            })}

            {/* SÉPARATEUR PREMIUM */}
            <div className="pp-separator">
              <div className="pp-separator-line"/>
              <span className="pp-separator-label">Modules Premium</span>
              <div className="pp-separator-line"/>
            </div>

            {MODULE_INFO.filter(m => m.premium).map((mod, pidx) => {
              const acces = canAccess(mod.num, true);
              const valide = modulesValides.includes(mod.num);
              const actif  = mod.num === moduleActuel && acces;
              const modClass = `pp-mod ${valide ? 'done' : ''} ${actif ? 'active' : ''} ${!acces ? 'premium-locked' : ''}`;

              const inner = (
                <>
                  <div className={`pp-circle ${valide ? 'done' : actif ? 'active' : 'premium'}`}>{valide ? '✓' : mod.emoji}</div>
                  <div className="pp-mod-info">
                    <div className="pp-mod-num">Module {String(6 + pidx).padStart(2,'0')} · Premium</div>
                    <div className="pp-mod-title">{mod.titre}</div>
                    <div className="pp-mod-desc">{mod.desc}</div>
                  </div>
                  <div className="pp-mod-right">
                    {valide && <span className="pp-badge pp-badge-done">✓ Complété</span>}
                    {!valide && <span className="pp-badge pp-badge-pro">PRO</span>}
                    {!acces && <span style={{fontSize:16}}>🔒</span>}
                    <div className="pp-mod-time">⏱ {mod.temps} min</div>
                  </div>
                </>
              );

              if (acces) {
                return (
                  <a key={mod.num} href={`/module/${mod.num}`} target="_blank" rel="noreferrer" className={modClass}>
                    {inner}
                  </a>
                );
              }
              return <div key={mod.num} className={modClass} style={{cursor:'pointer'}} onClick={() => setShowAbo(true)}>{inner}</div>;
            })}
          </div>

          {/* PREMIUM CTA */}
          {!data?.premiumDebloque && (
            <div className="pp-cta">
              <div className="pp-cta-left">
                <div className="pp-cta-eyebrow">Passer au niveau supérieur</div>
                <div className="pp-cta-title">Passe à l'action et décroche tes premiers clients.</div>
                <div className="pp-cta-desc">
                  Le parcours Lancer te donne ta fiche Google, ta première campagne Meta et tes premiers clients, avec des livrables prêts à copier.
                </div>
              </div>
              <div className="pp-cta-right">
                <a href="#" className="pp-cta-btn" onClick={(e) => { e.preventDefault(); setShowAbo(true); }}>Découvrir le parcours Lancer →</a>
                <div className="pp-cta-note">Abonnement mensuel, sans engagement</div>
              </div>
            </div>
          )}

        </div>

        {/* FOOTER LÉGAL */}
        <div style={{textAlign:'center',padding:'20px 24px 32px',borderTop:'1px solid var(--line)',background:'#fff',fontSize:12,color:'#B0A898',display:'flex',alignItems:'center',justifyContent:'center',gap:20,flexWrap:'wrap'}}>
          <span>© 2026 Stratvente · BrandStarter</span>
          <a href="/mentions-legales" style={{color:'#B0A898',textDecoration:'none'}}>Mentions légales</a>
          <a href="/confidentialite" style={{color:'#B0A898',textDecoration:'none'}}>Politique de confidentialité</a>
          <a href="mailto:commercial@stratvente.com" style={{color:'#B0A898',textDecoration:'none'}}>Contact</a>
        </div>

        {showAbo && <AbonnementModal onClose={() => setShowAbo(false)} />}
      <BottomNav />
      </div>
    </>
  );
}
